// import { WgisService } from './wgis.service';
import { WGisServiceInterface } from './wgis.utils';

import Feature from 'ol/Feature';
// import Layer from 'ol/layer/Layer';
// import Point from 'ol/geom/Point';
// import WKT from 'ol/format/WKT';
import { WGisEngine } from './wgis.engine';
import { EngineType, FieldsInterface, MapEngineOptions, BaseEngine,
  WGisFeatureInfo, WGisFeatureInterface } from './wgis.utils';

import { Tile as TileLayer } from 'ol/layer';
import { OSM } from 'ol/source';


export class WGisOsmEngine extends WGisEngine implements BaseEngine {
  source: OSM;

  constructor(options: MapEngineOptions, wgisService: WGisServiceInterface) {
    super(options, wgisService);
    this.createLayer();
  }

  createLayer() {
    this.type = EngineType.OSM;
    this.source = new OSM();
    this.oLayer = new TileLayer({
      source: this.source
    });
    this.registerLayer();
  }

  buildFeature(
    geometry: string,
    attribute: FieldsInterface,
    info: WGisFeatureInfo): WGisFeatureInterface {
    return null;
  }

  feature_factory(fields: FieldsInterface, wkt: string, projection?: string): WGisFeatureInterface {
    return null;
  }
  saveSelection(): void {
  }

  // OVERIDE ME
  clearSelection(): void { }
  getSelection(): void { }
  addFeatureToSelection(feature: Feature) { }
  removeFeatureFromSelection(feature: Feature) { }
}
